import HttpClient from './HttpClient';
import HTTPResponse from './HttpResponse';
import { Customer } from './model';

class UserService {
  private http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  public async getCustomer(): Promise<HTTPResponse<Customer>> {
    const response = await this.http.get('user/get');
    return response;
  }

  public async updateCustomer(customer: {}): Promise<HTTPResponse<Customer>> {
    const response = await this.http.put('order', customer);
    return response;
  }

  public async createCustomer(customer: {}): Promise<HTTPResponse<Customer>> {
    const response = await this.http.post('order', customer);
    return response;
  }
}

export const userService = new UserService(new HttpClient());
